module.exports = __webpack_public_path__ + "static/img/icon_dafen.e474765.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/voiceScene/icon_dafen.png
// module id = 93
// module chunks = 0